import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, AlertDialog, Switch } from "react-onsenui";

import img5 from "./../assets/fbs/default.5.png";
import img51 from "./../assets/fbs/default.5.1.png";
import img4 from "./../assets/fbs/default.4.png";
import img41 from "./../assets/fbs/default.4.1.png";
import img3 from "./../assets/fbs/default.3.png";
import img31 from "./../assets/fbs/default.3.1.png";
import img2 from "./../assets/fbs/default.2.png";
import img1 from "./../assets/fbs/default.1.png";
import Lottie from "lottie-react";
import { getRatingTheme, DEFAULT_RATING_THEME_ID } from "./ratingThemes";
// import animAwaitingFeedback from "./../assets/fbs/fbs-awaiting-fb.json";
// import animGiftWaiting from "./../assets/fbs/fbs-gift-waiting.json";
import animThankYouStar from "./../assets/fbs/fbs-star-thankyou.json";
import animFloatingFb from "./../assets/fbs/feedback-floating-115241.json";
import imgBgBlur from "./../assets/fbs/bial/bg-rays.png"; //bg-airport.jpg -- last final = philip-oroni-EaFX0kRvXT8-unsplash-light.jpg
import imgBgBlurMobile from "./../assets/fbs/bial/bg-rays.png"; //runway.jpg
import encalmRDCLogo from "./../assets/fbs/encalm/RDC_logo.png";
import omanSadaLogo from "./../assets/fbs/oman/sada_logo.png";
import vesta32Logo from "./../assets/vesta.32.png";

import { paths } from "../App";
import { useForm, Controller } from "react-hook-form";
import { FbsOrgLanding } from "./FbsOrgLanding";
import { useNavigate } from "react-router-dom";
import { axiosInstance as axios } from "./../utils/axios";
import { axiosInstanceHttp as axiosExt } from "./../utils/axios";

import { deleteStorage, getStorage, setStorage } from "../utils/storage";
import { Icon } from "@iconify/react";
import { ErrorMessage } from "@hookform/error-message";
import {
    decodeUrlHashString,
    generateId,
    getUrlParameterByName,
} from "../utils/helpers";
import { default as QRCode } from "qrcode.react";
import {
    API_BASE,
    COMPANY_BRAND_NAME,
    PROFILE_IMG_FALLBACK,
    URL_BASE_FBS,
    getEnvVar,
} from "../config.common";
import {
    applyOrgTheme,
    getUrlThemeLogoAsset,
    RenderHeader,
    getLocationNameLS,
    getLocationIcon,
    uidGen,
    getFbsMetaLS,
    FBS_TEMPLATE_MISSING_MESSAGE,
} from "./fbs-common";
import { resolveUrlTheme } from "../themeConfig";

/* Phone Number Input 
   [https://www.npmjs.com/package/react-phone-input-2] 
*/
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { Autocomplete, TextField } from "@mui/material";
import { BlobServiceClient } from "@azure/storage-blob";
import NewAudioRecorder from "./NewAudioRecorder";
import { airlinesOptions } from "../_mock/airlines";
import FbsStaffSwitcher, { isStaffSwitchEnabled } from "./FbsStaffSwitcher";
import {
    FBS_DEFAULT_LANGUAGE,
    getFbsDefaultLanguage,
    getFbsOrgSettingValue,
    getFbsSupportedLanguages,
    getLanguageDirection,
    getStaticFbsText,
    resolveRatingOptionText,
    resolveTemplateLabel,
} from "./fbsTranslations";

export const PAGE_INDEX = {
    RATING: 0,
    SECTION: 1,
    SUBSECTION: 2,
    SECTION_POSITIVE: 3,
    SUBSECTION_POSITIVE: 4,
    FEEDBACK: 5,
};

/** First word of on-duty staff name (tile on /t/feedback only) — e.g. fname "Lubna Zahir…" → "Lubna". */
function firstWordToken(s) {
    const t = (s ?? "").trim();
    if (!t) return "";
    return t.split(/\s+/)[0] ?? t;
}

function staffOnDutyFirstName(staff) {
    if (!staff?.id) return "Unassigned";
    const fromFname = firstWordToken(staff.fname);
    if (fromFname) return fromFname;
    const fromName = firstWordToken(staff.name);
    if (fromName) return fromName;
    const u = (staff.username ?? "").trim();
    return (u ? firstWordToken(u) || u : "") || "Unassigned";
}

export function FbsLanding(props) {
    const viewType = props?.viewType ?? "tablet"; // mobile/tablet
    const isMobile = viewType === "mobile";
    const isTablet = viewType === "tablet";

    const bgImage = isMobile ? imgBgBlurMobile : imgBgBlur;
    const fullScreenOverlayBaseStyle = {
        position: "absolute",
        top: 0,
        backgroundImage: `url(${bgImage})`,
        width: "100%",
        height: "100vh",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
    };

    const config = {
        autoSubmitCertainRatings: true,
        autoSubmitRatingThreshold: 4,
        iconifyIconSize: isTablet ? 80 : 64,
        screenPauseTimeMs: 3000,
        /** Oman tablet: short thank-you then reset while POST /fbs/public/create finishes (slow negative-feedback path). */
        omanTabletThankYouMs: 2500,
        enableEnticer: false,
    };

    const ratings = {
        three: [
            {
                score: 3,
                img: img5,
                name: "Excellent",
                nameKey: "rating.excellent",
            },
            { score: 2, img: img3, name: "Average", nameKey: "rating.average" },
            { score: 1, img: img2, name: "Poor", nameKey: "rating.poor" },
        ],
        generic: [
            { score: 1, img: img1, name: "Bad", nameKey: "rating.bad" },
            { score: 2, img: img2, name: "Poor", nameKey: "rating.poor" },
            { score: 3, img: img3, name: "Average", nameKey: "rating.average" },
            { score: 4, img: img4, name: "Good", nameKey: "rating.good" },
            {
                score: 5,
                img: img5,
                name: "Excellent",
                nameKey: "rating.excellent",
            },
        ],
        gmrHyd: [
            {
                score: 5,
                img: img5,
                name: "Excellent",
                nameKey: "rating.excellent",
                text: "Thank you for your feedback",
                textKey: "rating.thankYou",
            },
            {
                score: 4,
                img: img41,
                name: "Very Good",
                text: "Thank you for your feedback",
                nameKey: "rating.veryGood",
                textKey: "rating.thankYou",
            },
            {
                score: 3,
                img: img3,
                name: "Good",
                text: "Where can we improve?",
                nameKey: "rating.good",
                textKey: "rating.whereImprove",
            },
            {
                score: 2,
                img: img31,
                name: "Fair",
                text: "How can we make things right?",
                nameKey: "rating.fair",
                textKey: "rating.makeRight",
            },
            {
                score: 1,
                img: img2,
                name: "Poor",
                text: "How can we make things right?",
                nameKey: "rating.poor",
                textKey: "rating.makeRight",
            },
        ],
    };

    /*  =================================================================================== */
    /* Device UID for rate limiting (Adani requirement: Max 2 feedbacks per device per day) */
    const getOrCreateDeviceUID = () => {
        let deviceUid = localStorage.getItem("vesta_device_uid");
        if (!deviceUid) {
            deviceUid =
                "dev_" +
                Date.now() +
                "_" +
                Math.random().toString(36).substr(2, 9);
            localStorage.setItem("vesta_device_uid", deviceUid);
        }
        return deviceUid;
    };
    const [deviceUID] = useState(getOrCreateDeviceUID());

    /* Check device submission limit before feedback submission (Adani-specific) */
    const checkDeviceSubmissionLimit = (orgId) => {
        // Check if device limit applies: Adani environment only
        const isAdani =
            window.location.href.includes("adani") ||
            window.location.href.includes("azurewebsites");

        // Skip check if not in Adani environment
        if (!isAdani) {
            return Promise.resolve();
        }

        // Call device limit check API
        return axios
            .post("/fbs/public/check-device-limit", {
                device_uid: deviceUID,
                org_id: orgId,
            })
            .then((limitCheckResponse) => {
                if (!limitCheckResponse.data.allowed) {
                    // Device has reached daily limit
                    alert(
                        limitCheckResponse.data.message ||
                            getStaticFbsText(
                                "alert.deviceLimit",
                                selectedLanguage,
                            ),
                    );
                    setIsFormReady(true);
                    setIsSubmittingFeedback(false);
                    return Promise.reject("DEVICE_LIMIT_REACHED");
                }
                return Promise.resolve();
            })
            .catch((limitCheckError) => {
                if (limitCheckError === "DEVICE_LIMIT_REACHED") {
                    return Promise.reject(limitCheckError);
                }
                console.error("Device limit check failed:", limitCheckError);
                // Continue with submission if check API fails (non-blocking)
                return Promise.resolve();
            });
    };
    /*  =================================================================================== */

    /* Idle timer for tablet view */
    const timeout = 30000; // 30 seconds
    const [idle, setIdle] = useState(false);

    /* Ref keeps the latest handler without causing the effect to re-run */
    const onIdleRef = useRef(null);
    onIdleRef.current = () => {
        if (!isTablet || 0 == viewIndex) return;
        resetPage();
        setIdle(false);
    };

    useEffect(() => {
        let timeoutId;

        const resetTimeout = () => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIdle(true);
                onIdleRef.current?.();
            }, timeout);
        };

        const handleUserActivity = () => {
            setIdle(false);
            resetTimeout();
        };

        resetTimeout();

        window.addEventListener("mousemove", handleUserActivity);
        window.addEventListener("keydown", handleUserActivity);
        window.addEventListener("touchstart", handleUserActivity);

        return () => {
            window.removeEventListener("mousemove", handleUserActivity);
            window.removeEventListener("keydown", handleUserActivity);
            window.removeEventListener("touchstart", handleUserActivity);
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // runs once — onIdleRef.current always holds the latest handler

    /* Active Rating Context */
    const [ratingContext, setRatingContext] = useState({});

    useEffect(() => {
        setRatingContext({
            triggerThreshold: 3, // default `negative` review threshold
            triggerThresholdPositive: 3, // default `positive` review threshold
            ratingsTemplate: ratings.gmrHyd,
            keepAlivePing: 45, // minutes
        });
        document.title = `Feedback System by ${COMPANY_BRAND_NAME}`;
    }, []);

    const navigateStepWithRating = (step, currentRating) =>
        navigateStep(step, null, null, currentRating, null);

    const [isGoingBack, setIsGoingBack] = useState(false);
    const navigateStep = (
        step,
        from = viewIndex,
        secIndex = stateSectionIndex,
        ratingCurrentSync = rating,
        secPosIndex = stateSectionPosIndex,
    ) => {
        setIsGoingBack(step < 0);
        if (step < 0) {
            switch (viewIndex) {
                case PAGE_INDEX.SECTION:
                    setSectionIndex(null);
                    break;
                case PAGE_INDEX.SUBSECTION:
                    setSubSectionIndex(null);
                    break;
                case PAGE_INDEX.SECTION_POSITIVE:
                    setSectionPosIndex(null);
                    break;
                case PAGE_INDEX.SUBSECTION_POSITIVE:
                    setSubSectionPosIndex(null);
                    break;
                default:
                case PAGE_INDEX.FEEDBACK:
                    if (!orgRatingData) {
                        // Don't reset form if we're coming from organizational feedback
                        reset();
                    }
                    break;
            }
        }
        console.log("isGoingBack?", isGoingBack);
        console.log("current rating", ratingCurrentSync, rating);
        let thresholdNegReview = parseInt(
            template?.meta?.threshold ?? ratingContext.triggerThreshold,
        );
        let thresholdAutoSubmit = parseInt(
            template?.meta?.threshold_autoSubmit ??
                config.autoSubmitRatingThreshold,
        );
        let thresholdPosReview = parseInt(
            template?.meta?.threshold_positive ??
                ratingContext.triggerThresholdPositive,
        );
        console.log(
            "thresholdNegReview",
            thresholdNegReview,
            "thresholdAutoSubmit",
            thresholdAutoSubmit,
            "thresholdPosReview",
            thresholdPosReview,
        );
        let targetStep = from + step;
        let ratingSkippable = ratingCurrentSync > thresholdNegReview;
        let delighterSkippable = ratingCurrentSync < thresholdPosReview;
        console.log("from,to:", from, targetStep);
        console.log(
            "ratingSkippable",
            ratingSkippable,
            "delighterSkippable",
            delighterSkippable,
        );

        /* Skip flow & Auto-submit ? (only on forward navigation) */
        let autoSubmitDisabled = 0 === thresholdAutoSubmit;
        if (
            step > 0 &&
            config.autoSubmitCertainRatings &&
            ratingCurrentSync >= thresholdAutoSubmit &&
            !autoSubmitDisabled
        ) {
            console.log(
                "Auto-submitting for rating",
                ratingCurrentSync,
                "thresholdAutoSubmit:",
                thresholdAutoSubmit,
            );
            setAutoSubmit(true);
            return;
        } else setAutoSubmit(false);

        switch (targetStep) {
            case PAGE_INDEX.RATING:
                delayedLoadView(PAGE_INDEX.RATING);
                break;
            case PAGE_INDEX.SECTION:
                if (ratingSkippable || !template?.content?.sections?.length)
                    navigateStep(
                        step,
                        PAGE_INDEX.SECTION,
                        null,
                        ratingCurrentSync,
                    );
                else delayedLoadView(PAGE_INDEX.SECTION);
                break;
            case PAGE_INDEX.SUBSECTION:
                if (
                    ratingSkippable ||
                    !template?.content?.sections?.[secIndex]?.sections?.length
                )
                    navigateStep(
                        step,
                        PAGE_INDEX.SUBSECTION,
                        null,
                        ratingCurrentSync,
                        secIndex,
                    );
                else delayedLoadView(PAGE_INDEX.SUBSECTION);
                break;
            case PAGE_INDEX.SECTION_POSITIVE:
                if (
                    delighterSkippable ||
                    !template?.content?.sectionsPositive?.length
                )
                    navigateStep(step, PAGE_INDEX.SECTION_POSITIVE);
                else delayedLoadView(PAGE_INDEX.SECTION_POSITIVE);
                break;
            case PAGE_INDEX.SUBSECTION_POSITIVE:
                if (
                    delighterSkippable ||
                    !template?.content?.sectionsPositive?.[secPosIndex]
                        ?.sections?.length
                )
                    navigateStep(step, PAGE_INDEX.SUBSECTION_POSITIVE);
                else delayedLoadView(PAGE_INDEX.SUBSECTION_POSITIVE);
                break;
            case PAGE_INDEX.FEEDBACK:
                delayedLoadView(PAGE_INDEX.FEEDBACK);
                break;
            default:
                console.log("INVALID PAGE-SWITCH CASE");
                break;
        }
    };

    const [isTransitioning, setIsTransitioning] = useState(false);
    const delayedLoadView = (viewIndex) => {
        setIsTransitioning(true);
        setTimeout(() => {
            setViewIndex(viewIndex);
            setIsTransitioning(false);
        }, 125);
    };

    const [showEnticer, setShowEnticer] = useState(
        isTablet && config.enableEnticer,
    );
    const [showThankYou, setShowThankYou] = useState(false);
    const [feedbackID, setFeedbackId] = useState(null);
    /** Oman tablet fast submit: ID arrives late or stale; suppress on thank-you overlay. */
    const [hideFeedbackIdOnThankYou, setHideFeedbackIdOnThankYou] =
        useState(false);
    const [showBlockingLoader, setShowBlockingLoader] = useState(isMobile);
    const [templateMissing, setTemplateMissing] = useState(false);
    const [templateMissingMessage, setTemplateMissingMessage] = useState("");

    const [rating, setRating] = useState(null);
    const [ratingIndex, setRatingIndex] = useState(null);
    const [stateSectionIndex, setSectionIndex] = useState(null);
    const [stateSubSectionIndex, setSubSectionIndex] = useState(null);
    const [stateSectionPosIndex, setSectionPosIndex] = useState(null);
    const [stateSubSectionPosIndex, setSubSectionPosIndex] = useState(null);

    const [user, setUser] = useState(getStorage("u4"));
    const [fbsMeta, setFbsMeta] = useState(getStorage("fbsMeta"));
    const [template, setTemplate] = useState(getStorage("template"));
    const [selectedLanguage, setSelectedLanguage] = useState(
        localStorage.getItem("fbs_selected_language") || FBS_DEFAULT_LANGUAGE,
    );
    const [assocStaff, setAssocStaff] = useState(getStorage("assocStaff"));
    const [assocShift, setAssocShift] = useState(getStorage("assocShift"));
    const [orgSupervisor, setOrgSupervisor] = useState(null);
    const [orgSupervisorsOptional, setOrgSupervisorsOptional] = useState(null);
    const [viewIndex, setViewIndex] = useState(0);
    const [isFormReady, setIsFormReady] = useState(true);
    const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
    const [audioFeedback, setAudioFeedback] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioMimeType, setAudioMimeType] = useState("");
    const [mp3Blob, setMp3Blob] = useState(null);
    const [isExpired, setIsExpired] = useState(false);
    const [orgRatingData, setOrgRatingData] = useState(null);
    const [orgCategoryRatings, setOrgCategoryRatings] = useState({});
    const [orgCategoryIssues, setOrgCategoryIssues] = useState({});
    const templateSections = Array.isArray(template?.content?.sections)
        ? template.content.sections
        : [];
    const templatePositiveSections = Array.isArray(
        template?.content?.sectionsPositive,
    )
        ? template.content.sectionsPositive
        : [];

    /* Staff Switcher */
    const [staffSwitcherOpen, setStaffSwitcherOpen] = useState(false);
    const staffSwitchEnabled = isStaffSwitchEnabled(template, fbsMeta);

    const [autoSubmit, setAutoSubmit] = useState(false);
    /* Auto-submit */
    useEffect(() => {
        if (!rating || !autoSubmit) return;
        onSubmit({ text: "", uMob: "", autoSubmit: true });
    }, [rating, autoSubmit]);

    // Enable VirtualKeyboard API so env(keyboard-inset-height) works in CSS
    useEffect(() => {
        if (navigator.virtualKeyboard) {
            navigator.virtualKeyboard.overlaysContent = true;
        }
    }, []);

    const dismissEnticer = () => {
        resetPage();
        setShowEnticer(false);
    };

    const setTheRating = (v) => setRating(v);
    const setTheRatingIndex = (v) => setRatingIndex(v);
    const resetPage = () => {
        reset();
        setRating(null);
        setRatingIndex(null);
        setSectionIndex(null);
        setSubSectionIndex(null);
        setSectionPosIndex(null);
        setSubSectionPosIndex(null);
        setViewIndex(0);
        setOrgRatingData(null);
        setOrgCategoryRatings({});
        setOrgCategoryIssues({});
        setAutoSubmit(false);
        setIsSubmittingFeedback(false);
        setIsFormReady(true);
        setHideFeedbackIdOnThankYou(false);
    };

    const intervalDevicePing = React.useRef();
    useEffect(() => {
        if (!ratingContext || !ratingContext.ratingsTemplate) return;
        if (!fbsMeta || !fbsMeta.org_id) return;
        getTheTemplate().then((x) => {});
        if (isTablet) {
            sendPing();
            let timeIntervalMins = parseInt(ratingContext?.keepAlivePing ?? 30);
            if (timeIntervalMins < 30) timeIntervalMins = 30;
            intervalDevicePing.current = setInterval(
                () => {
                    sendPing();
                },
                timeIntervalMins * 1000 * 60,
            );
            console.log("Setting Ping Interval as", timeIntervalMins, "m");
        }
        return () => {
            clearInterval(intervalDevicePing.current);
        };
    }, [fbsMeta, ratingContext]);

    /* Mobile, URL param passed? Set fbsMeta */
    useEffect(() => {
        if (isMobile) {
            setShowBlockingLoader(true);
            let hash = getUrlParameterByName("hash", window.location);
            let decoded = decodeUrlHashString(hash);
            console.log("params", hash);
            console.log("decoded", decoded);

            // Check expiration first
            if (decoded?.gen_time) {
                const expired = isLinkExpired(decoded.gen_time);
                setIsExpired(expired);

                if (expired) {
                    setShowBlockingLoader(false); // Set showBlockingLoader to false when QR is expired so the expired message can be seen
                    // Skip further processing if expired
                    return;
                }
            }
            if (!decoded || !decoded.oi) {
                setShowThankYou(true); // something is wrong OR user has already submitted
                setShowBlockingLoader(false);
            }

            /* ======== Special Case ======== */
            /* On Checkinn (AWS), redirect Encalm request to Azure India Servers */
            if (
                window.location.hostname === "fbs.checkinn.co" ||
                window.location.hostname.endsWith(".checkinn.co")
            ) {
                console.log("On CheckInn Main Server");
                let org_id = "" + decoded?.oi;
                if (["1071", "1072", "1073"].includes(org_id)) {
                    console.log(
                        "Redirecting for Encalm to Azure India Servers",
                    );
                    window.location.href =
                        "https://fbs.teamvesta.com/m/feedback?hash=" + hash; // fbs. = Azure Indian DB backend server
                    return;
                } else {
                    console.log("No redirect");
                }
            }
            /* ======== /Special Case ======== */

            /* Pretty URL: drop `hash` from the address bar but keep other query params
             * (e.g. `oman=1` for local dev URL-based theme). Otherwise replaceState wipes
             * `?oman=1` and resolveUrlTheme() stops matching — Oman logo / QR strip break. */
            const keptParams = new URLSearchParams(window.location.search);
            keptParams.delete("hash");
            const keptQs = keptParams.toString();
            window.history.replaceState(
                {},
                document.title,
                "share-your-feedback" + (keptQs ? `?${keptQs}` : ""),
            );
            /* Since we are using thin data without login API call, fill up essential data in same format as required by onSubmit */
            setFbsMeta({
                org_id: decoded?.oi,
                location: {
                    location: decoded?.lon ?? "Unknown",
                    id: decoded?.loi ?? 0,
                },
            });
        }
    }, []);

    const sendPing = () => {
        if (!isTablet) return;
        console.log("Pinging...");
        axios
            .post("fbs/ping", {
                location_id: fbsMeta?.location?.id,
                org_id: fbsMeta?.org_id,
                device_id:
                    fbsMeta?.tabUid + "-" + fbsMeta?.tabName || "Unnamed",
            })
            .then((r) => {});
    };

    const intervalRefetchTemplate = React.useRef();
    useEffect(() => {
        if (assocStaff?.id) {
            intervalRefetchTemplate.current = setInterval(
                getTheTemplate,
                5 * 60 * 1000,
            ); // 5 mins
        }
        return () => {
            clearInterval(intervalRefetchTemplate.current);
        };
    }, [assocStaff]);

    const isLinkExpired = (genTimeStr) => {
        if (!genTimeStr || genTimeStr.length !== 6) {
            return true;
        }

        const day = parseInt(genTimeStr.substring(0, 2), 10);
        const hour = parseInt(genTimeStr.substring(2, 4), 10);
        const minute = parseInt(genTimeStr.substring(4, 6), 10);

        if (
            isNaN(day) ||
            isNaN(hour) ||
            isNaN(minute) ||
            day < 1 ||
            day > 31 ||
            hour < 0 ||
            hour > 23 ||
            minute < 0 ||
            minute > 59
        ) {
            return true;
        }

        const now = new Date();
        let genDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            day,
            hour,
            minute,
        );

        console.log("Gen time :", genDate.toString());

        if (genDate > now) {
            genDate.setMonth(genDate.getMonth() - 1);
            if (genDate > now) {
                genDate.setFullYear(genDate.getFullYear() - 1);
            }
        }

        const genHour = genDate.getHours();
        let shiftEnd = new Date(genDate);

        if (genHour >= 7 && genHour < 15) {
            shiftEnd.setHours(15, 20, 0, 0);
            console.log("Shift 1 end:", shiftEnd.toString());
        } else if (genHour >= 15 && genHour < 22) {
            shiftEnd.setHours(22, 20, 0, 0);
            console.log("Shift 2 end:", shiftEnd.toString());
        } else {
            // For times between 22:00 and 06:59 - night shift (expires the next day at 07:20)
            if (genHour >= 22) {
                shiftEnd.setDate(shiftEnd.getDate() + 1);
                console.log("Shift 3 end (night shift):", shiftEnd.toString());
            } else {
                // For times between 00:00 and 06:59 (expires same day at 07:20)
                console.log(
                    "Shift 3 end (early morning):",
                    shiftEnd.toString(),
                );
            }
            shiftEnd.setHours(7, 20, 0, 0);
        }

        const expired = now > shiftEnd;
        console.log("Is link expired:", expired);
        return expired;
    };

    const getTheTemplate = async () => {
        //let apiUrl = isMobile?"/fbs/public/get-the-template":"/fbs/get-the-template";
        console.log("Refreshing Feedback Template");
        let apiUrl = "/fbs/public/get-the-template"; // unified code
        try {
            let response = await axios.post(apiUrl, {
                location_id: fbsMeta?.location?.id,
                org_id: fbsMeta?.org_id,
            });
            const orgId = parseInt(fbsMeta?.org_id, 10);
            const isTargetOrg = orgId === 1083;

            // Frontend-only guard (org-scoped): if template isn't resolved (id=0) or API returned nothing,
            // show rescan message and stop flow.
            if (isTargetOrg && (!response?.data || !response?.data?.id || response?.data?.id === 0)) {
                setTemplateMissing(true);
                setTemplateMissingMessage(FBS_TEMPLATE_MISSING_MESSAGE);
                return;
            }

            if (response?.data?.id === 0) {
                console.error(
                    "No associated templates found for " +
                        fbsMeta?.location?.location +
                        ". Using default",
                );
            } else if (response && response.data) {
                console.log("Setting Feedback Template");
                setTemplate(response.data);
            }
            if (isMobile) {
                setStorage("u4", { hotel: response?.data?.org });
                setUser({ hotel: response?.data?.org });
            }

            /* Set Associated Staff */
            if (response?.data?.location?.assoc_staff?.id ?? false) {
                setAssocStaff(response?.data?.location?.assoc_staff);
                /* Set Org Supervisor - when there is a assoc staff*/
                if (response?.data?.location?.meta?.supervisor_org) {
                    setOrgSupervisor(
                        response.data.location.meta.supervisor_org,
                    );
                    setOrgSupervisorsOptional(
                        response.data.location.meta.supervisor_org_optional,
                    );
                } else {
                    setOrgSupervisor(null);
                    setOrgSupervisorsOptional(null);
                }
            } else setAssocStaff(null);
            /* Set Associated Shift */
            if (response?.data?.location?.assoc_shift?.id ?? false) {
                setAssocShift(response?.data?.location?.assoc_shift);
            } else setAssocShift(null);

            applyOrgTheme(
                response?.data?.org?.name,
                response?.data?.org?.shortname,
            );
        } catch (e) {
            console.error("Failed to fetch feedback template:", e);
        } finally {
            /* Turn loader off */
            setShowBlockingLoader(false);
        }
    };

    /* Form Submit */
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        formState: { errors },
        control,
    } = useForm();

    const vestaIntegration = async (formDat) => {
        return;
        // const settings = template?.org?.settings ?? {};
        // let extVestaIntegration = settings?.find((x) => x.key === 'externalVestaIntegration')?.value ?? null;
        // let extVestaOrgToken = settings?.find((x) => x.key === 'externalVestaOrgToken')?.value ?? null;
        // let extVestaOrgId = settings?.find((x) => x.key === 'externalVestaOrgId')?.value ?? null;
        // let extVestaBaseUrl = settings?.find((x) => x.key === 'externalVestaBaseUrl')?.value ?? null;

        // if ((extVestaIntegration === "true") && (!!extVestaOrgToken && !!extVestaOrgId && !!extVestaBaseUrl)) {
        //     console.log("Vesta Integration Enabled")
        //     let resp = axiosExt.post(`${extVestaBaseUrl}api/v1/vesta/create`, { trig: 'fbs', user_id: 0, org_id: extVestaOrgId, org_token: extVestaOrgToken, item_id: formDat.item_id, comments: formDat.text || '', location: formDat.location });
        // }
    };

    const uploadBlobToAzure = async (file) => {
        const accountKey = process.env.REACT_APP_AZINDBLOB_ACCOUNT_KEY;
        const accountName = process.env.REACT_APP_AZINDBLOB_ACCOUNT_NAME;
        const containerName = process.env.REACT_APP_AZINDBLOB_CONTAINER_NAME;
        const sasToken = process.env.REACT_APP_AZINDBLOB_SAS_TOKEN;

        const blobServiceClient = new BlobServiceClient(
            `https://${accountName}.blob.core.windows.net?${sasToken}`,
        );

        const containerClient =
            blobServiceClient.getContainerClient(containerName);

        const blobName = file.name;
        const blockBlobClient = containerClient.getBlockBlobClient(blobName);

        try {
            // Upload the blob
            const options = { blobHTTPHeaders: { blobContentType: file.type } };

            await blockBlobClient.uploadBrowserData(file);

            const url = `https://vestaindia.blob.core.windows.net/${containerName}/${blobName}`;

            console.log("Blob uploaded successfully!");
            return url;
        } catch (error) {
            console.error("Error uploading blob:", error.message);
            return null;
        }
    };

    function blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function () {
                var dataUrl = reader.result;
                resolve(dataUrl);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    function base64ToBlob(base64DataUrl) {
        const splitDataUrl = base64DataUrl.split(",");
        const contentType = splitDataUrl[0].split(":")[1].split(";")[0];
        const byteCharacters = atob(splitDataUrl[1]);
        const byteArrays = [];

        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }

        const byteArray = new Uint8Array(byteArrays);
        return new Blob([byteArray], { type: contentType });
    }

    const transcribe = async (blob, fbsId) => {
        try {
            const base64Url = await blobToBase64(blob);
            let newBlob = base64ToBlob(base64Url);

            var file = new File([newBlob], `user_audio_${Date.now()}.webm`, {
                type: "audio/webm",
            });

            let audioUrl = await uploadBlobToAzure(file);

            console.log("file size", file.size);
            console.log("blob size", blob.size);
            console.log("file size", blob);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("fbsId", fbsId);
            formData.append("audioUrl", audioUrl);
            // formData.append("mp3Audio", mp3Blob);
            // formData.append("base64Url", base64Url);

            let res = await axios.post("/fbs/public/transcribe", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log(res);
        } catch (e) {
            console.log(e);
        }
    };

    const onSubmit = (formData, e) => {
        // Otp validation; verification
        let otpIsMandatory = config_shouldValidateOtp && watch("uMob");
        if (otpIsMandatory && !otpValidated) {
            setOtpValidated(false);
            setOtpValidationMessage(t("alert.verifyMobile"));
            return;
        }

        // Submit type
        let targetId = e?.target?.id ?? "fbs-main-submit";
        setIsFormReady(false);
        setIsSubmittingFeedback(true);

        /* Org_id precedence: Login User's org ID first (templates shared b/w orgs use-case) >> fbsMeta org_id >> template's org_id */
        let org_id = user?.hotel_id ?? fbsMeta?.org_id ?? template?.org_id;

        // Org-scoped guard (frontend-only): do not allow submission without a valid template id.
        if (
            (parseInt(org_id, 10) === 1083 && !template?.id) ||
            templateMissing
        ) {
            setTemplateMissing(true);
            setTemplateMissingMessage(FBS_TEMPLATE_MISSING_MESSAGE);
            setIsSubmittingFeedback(false);
            setIsFormReady(true);
            return;
        }

        console.log("formData passed", formData);
        // Split airLine object into airline (name) and airlineId (id)
        if (formData.airlineObj && typeof formData.airlineObj === "object") {
            formData.airline_id = formData.airlineObj.id ?? null;
            formData.airline = formData.airlineObj.name ?? null;
            delete formData.airlineObj; // optional cleanup
        }

        formData.targetId = targetId;
        formData.org_id = org_id;
        formData.rating = rating;

        // Include org rating data if available
        if (orgRatingData) {
            formData.rating = orgRatingData.rating;
            formData.categories = orgRatingData.categories;
            formData.isOrgFeedback = true;
        }

        // if(!formData.text) formData.text="No comment";
        formData.location =
            template?.location?.location ??
            fbsMeta?.location?.location ??
            "Unknown";
        formData.location_id = fbsMeta?.location?.id ?? 0;
        formData.tablet_id =
            fbsMeta?.tabUid + "-" + fbsMeta?.tabName || "Unnamed"; // device_id
        formData.template_id = template?.id;
        formData.index_section = stateSectionIndex;
        formData.index_subSection = stateSubSectionIndex;
        formData.section = {
            ...(templateSections?.[stateSectionIndex] ?? {}),
        };
        delete formData.section.sections;
        formData.subSection = {
            ...(templateSections?.[stateSectionIndex]?.sections?.[
                stateSubSectionIndex
            ] ?? {}),
        };
        delete formData.subSection.sections;

        formData.index_sectionPositive = stateSectionPosIndex;
        formData.index_subSectionPositive = stateSubSectionPosIndex;
        formData.sectionPositive = templatePositiveSections.length
            ? { ...(templatePositiveSections?.[stateSectionPosIndex] ?? {}) }
            : {};
        delete formData.sectionPositive.sections;
        formData.subSectionPositive = templatePositiveSections.length
            ? {
                  ...(templatePositiveSections?.[stateSectionPosIndex]?.sections?.[
                      stateSubSectionPosIndex
                  ] ?? {}),
              }
            : {};
        formData.item_id = formData.subSection?.item_id;
        delete formData.subSectionPositive.sections;

        if (Object.keys(formData.section).length) {
            formData.type = "Issue";
        } else if (Object.keys(formData.sectionPositive).length) {
            formData.type = "Delighters";
        } else {
            if (formData.isOrgFeedback) {
                formData.type = "OrgRating";
            } else {
                formData.type = "Unknown"; // default value in case neither section nor sectionPositive has data
            }
        }

        if (formData.autoSubmit) {
            /* FIX: If user rates 1, reaches end, then navigates back and clicks 5, the autoSubmit would also submit Issue Section, subSection selected previously */
            delete formData.section;
            delete formData.subSection;
            delete formData.index_section;
            delete formData.index_subSection;
            delete formData.sectionPositive;
            delete formData.subSectionPositive;
            delete formData.index_sectionPositive;
            delete formData.index_subSectionPositive;
        }
        if (isMobile) {
            console.log("onSubmit: isMobile");
            formData.tablet_id = "Mobile";
            formData.device_id = window.navigator.userAgent;
        }

        // Add device_uid for rate limiting
        formData.device_uid = deviceUID;

        // Add Associated Staff details
        if (assocStaff?.id) {
            formData.assocStaff = assocStaff;
        }

        // Add Org Supervisor details
        if (orgSupervisor) {
            formData.orgSupervisor = orgSupervisor;
        }

        // Add Org Supervisor Optional details
        if (orgSupervisorsOptional) {
            formData.orgSupervisorsOptional = orgSupervisorsOptional;
        }

        console.log("formData processed", formData);
        // let apiUrl = isMobile?"/fbs/public/create":"/fbs/create";
        const apiUrl = "/fbs/public/create"; // unified code

        /** Shared success handling after POST /fbs/public/create returns (single place for drift-prone logic). */
        const finalizeCreateRequest = (
            response,
            { transcribeHere = false } = {},
        ) => {
            console.log("Result Data: ", response?.data);
            setFeedbackId(response?.data?.id ?? null);
            if (
                transcribeHere &&
                response?.data &&
                audioBlob != null
            ) {
                transcribe(audioBlob, response.data.id);
            }
            return vestaIntegration(formData).then((integrationRes) => {
                console.log("Vesta Integration Response", integrationRes);
                return integrationRes;
            });
        };

        const afterAPICall = (flow = "default", res = null, options = {}) => {
            setIsSubmittingFeedback(false);
            if (res && audioBlob != null) {
                transcribe(audioBlob, res.id);
            }

            setShowEnticer(isTablet && config.enableEnticer);
            setShowThankYou(true);
            let screenOverlayTime =
                options.thankYouMsOverride !== undefined
                    ? options.thankYouMsOverride
                    : "giveMoreFeedback" === flow
                      ? 0
                      : config.screenPauseTimeMs;
            setTimeout(() => {
                if ("default" === flow) {
                    resetPage();
                    if (isTablet) setShowThankYou(false);
                    setShowEnticer(isTablet && config.enableEnticer);
                } else if ("giveMoreFeedback" === flow) {
                    setShowThankYou(false);
                    setShowEnticer(false);
                    // Navigate directly to the right section without triggering auto-submit
                    if (rating >= config.autoSubmitRatingThreshold) {
                        delayedLoadView(
                            template?.content?.sectionsPositive?.length
                                ? PAGE_INDEX.SECTION_POSITIVE
                                : PAGE_INDEX.FEEDBACK,
                        );
                    } else {
                        delayedLoadView(
                            template?.content?.sections?.length
                                ? PAGE_INDEX.SECTION
                                : PAGE_INDEX.FEEDBACK,
                        );
                    }
                    setValue("text", "");
                    setIsFormReady(true);
                }
            }, screenOverlayTime);
            resetOTPState();
        };

        /* * /
        if(targetId === "fbs-main-submit") {
           axios.post(apiUrl,formData).then( (r) => {afterAPICall()}).catch(e=>{afterAPICall()});
        }
        else if(targetId === "fbs-give-more") {
            axios.post(apiUrl,formData).then( (r) => {afterAPICall("giveMoreFeedback"); }).catch(e=>{afterAPICall("giveMoreFeedback")});
        }
        // External Vesta Integration call
        vestaIntegration(formData).then(r => {console.log("Vesta Integration Response",r)}).catch(e=>{console.log("Vesta Integration Error",e)});
        /* */

        let axiosPromise = null;
        let afterAPICallArg = "";

        const omanTabletFastMainSubmit =
            isTablet &&
            resolveUrlTheme() === "theme-custom-oman" &&
            targetId === "fbs-main-submit";

        // Check device limit before submission (Adani-specific; unchanged for Oman)
        if (targetId === "fbs-main-submit") {
            afterAPICallArg = "default";
            if (omanTabletFastMainSubmit) {
                /* Oman tablet: thank-you + reset without waiting for slow create (external tasks). */
                checkDeviceSubmissionLimit(org_id)
                    .then(() => {
                        axios
                            .post(apiUrl, formData)
                            .then((r) =>
                                finalizeCreateRequest(r, {
                                    transcribeHere: true,
                                }),
                            )
                            .catch((e) => {
                                console.log(
                                    "Oman tablet: background submit error",
                                    e,
                                );
                            });

                        setHideFeedbackIdOnThankYou(true);
                        afterAPICall("default", null, {
                            thankYouMsOverride: config.omanTabletThankYouMs,
                        });
                    })
                    .catch((e) => {
                        console.log("Submit/Integration Error", e);
                        setIsSubmittingFeedback(false);
                        if (e !== "DEVICE_LIMIT_REACHED") {
                            setIsFormReady(true);
                        }
                    });
            } else {
                axiosPromise = checkDeviceSubmissionLimit(org_id).then(() =>
                    axios.post(apiUrl, formData),
                );
            }
        } else if (targetId === "fbs-give-more") {
            axiosPromise = checkDeviceSubmissionLimit(org_id).then(() =>
                axios.post(apiUrl, formData),
            );
            afterAPICallArg = "giveMoreFeedback";
        }

        if (axiosPromise) {
            axiosPromise
                .then((r) => {
                    afterAPICall(afterAPICallArg, r.data);
                    return finalizeCreateRequest(r, { transcribeHere: false });
                })
                .catch((e) => {
                    console.log("Submit/Integration Error", e);
                    setIsSubmittingFeedback(false);
                    if (e !== "DEVICE_LIMIT_REACHED") {
                        setIsFormReady(true);
                    }
                });
        }
    };

    const settings = template?.org?.settings ?? null;
    const config_tnc = getFbsOrgSettingValue(settings, "fbsSubmitTnc", null);
    const config_privacy = getFbsOrgSettingValue(
        settings,
        "fbsPrivacyPolicy",
        null,
    );
    const config_shouldValidateOtp =
        (getFbsOrgSettingValue(settings, "fbsOTPValidation", null) ===
            "true" &&
            getFbsOrgSettingValue(settings, "fbsOTPValidationProvider", null)) ??
        false;
    const config_items_color = getFbsOrgSettingValue(
        settings,
        "fbsItemsColor",
        null,
    );
    const config_hide_location =
        getFbsOrgSettingValue(settings, "fbsHideLocationOnTablet", null) ??
        null;
    const config_animated_rating_orgConfig =
        getFbsOrgSettingValue(settings, "fbsAnimatedRatings", null);
    const config_audio_feedback = getFbsOrgSettingValue(
        settings,
        "audioFeedback",
        null,
    );
    const config_show_average_rating =
        getFbsOrgSettingValue(settings, "showAverageRating", null) === "true";
    const config_enable_translations =
        getFbsOrgSettingValue(settings, "enableTranslations", null) ===
        "true";
    const config_enabled_translation_iso_keys =
        getFbsOrgSettingValue(settings, "enabledTranslationsISOkeys", "") ?? "";
    const supportedLanguages = getFbsSupportedLanguages(
        config_enabled_translation_iso_keys,
        config_enable_translations,
    );
    const defaultLanguage = getFbsDefaultLanguage(
        config_enabled_translation_iso_keys,
        config_enable_translations,
    );
    const resolvedLanguage = supportedLanguages.some(
        (language) => language.key === selectedLanguage,
    )
        ? selectedLanguage
        : defaultLanguage;
    const selectedLanguageDirection = getLanguageDirection(resolvedLanguage);
    const t = (key) => getStaticFbsText(key, resolvedLanguage);
    const tl = (entity) => resolveTemplateLabel(entity, resolvedLanguage);

    /* Rating theme decision: Template meta takes precedence; fall back to legacy fbsAnimatedRatings from org-config */
    const config_rating_theme = template?.meta?.ratingTheme ?? null;
    const effectiveThemeId =
        config_rating_theme ??
        (config_animated_rating_orgConfig === "true"
            ? "animatedEmojis"
            : DEFAULT_RATING_THEME_ID);
    const activeRatingTheme = getRatingTheme(effectiveThemeId);
    /* Rating theme decision complete */

    useEffect(() => {
        const nextLanguage = supportedLanguages.some(
            (language) => language.key === selectedLanguage,
        )
            ? selectedLanguage
            : defaultLanguage;

        if (nextLanguage !== selectedLanguage) {
            setSelectedLanguage(nextLanguage);
            return;
        }

        localStorage.setItem("fbs_selected_language", nextLanguage);
    }, [defaultLanguage, selectedLanguage, supportedLanguages]);

    const getRatingHeadingText = () => (
        <>
            {rating &&
                resolveRatingOptionText(
                    activeRatingTheme?.ratings[ratingIndex]?.text,
                    activeRatingTheme?.ratings[ratingIndex]?.textKey,
                    resolvedLanguage,
                )}
        </>
    );
    const getRatingSectionText = () => <>{t("screen.whatNeedsImprovement")}</>;
    const getRatingSubSectionText = () => (
        <>{t("screen.whatNeedsImprovement")}</>
    );
    const getDelighterSectionText = () => <>{t("screen.whatLikedServices")}</>;
    const getDelighterSubSectionText = () => (
        <>{t("screen.whatLikedServices")}</>
    );

    const orgId = template?.org?.id ?? template?.org_id;
    const orgShortName = (template?.org?.shortname ?? "").trim();
    const isBialOrg =
        Number(orgId) === 1083 && orgShortName.toUpperCase() === "BIAL"; // @todo: revisit!
    const isOmanTheme = resolveUrlTheme() === "theme-custom-oman";
    const [omanLogoutOpen, setOmanLogoutOpen] = useState(false);
    const _qrPrepend = URL_BASE_FBS + "/m/feedback?hash=";
    const _qrPayload = {
        loi: fbsMeta?.location?.id,
        lon: fbsMeta?.location?.location,
        id: Math.ceil(Math.random() * 100),
        hashKey: generateId(6),
        oi: fbsMeta?.location?.org_id ?? fbsMeta?.org_id,
    };
    const _qrText = btoa(
        unescape(encodeURIComponent(JSON.stringify(_qrPayload))),
    );
    const validateMobileNumber = (value, isMandatory = false) => {
        if (!value || value.trim() === "") {
            return isMandatory ? t("form.invalidMobileNumber") : true;
        }

        const compactValue = value.replace(/\s+/g, "");
        const digitsOnly = (value.match(/\d/g) || []).join("");
        if (!digitsOnly) {
            return t("form.invalidMobileNumber");
        }

        let localDigits = digitsOnly;
        // Check if it's an Indian number: has +91 prefix OR has 12+ digits starting with 91 (country code included)
        const isIndia =
            compactValue.startsWith("+91") ||
            (digitsOnly.length >= 12 && digitsOnly.startsWith("91"));

        // Only strip country code if it's actually present (number is 12+ digits with 91 prefix)
        // This prevents stripping '91' from valid 10-digit numbers that start with 91
        if (
            isIndia &&
            digitsOnly.length >= 12 &&
            localDigits.startsWith("91")
        ) {
            localDigits = localDigits.slice(2);
        }

        const targetDigits = localDigits || digitsOnly;

        if (targetDigits.length >= 4 && /^(\d)\1+$/.test(targetDigits)) {
            return t("form.invalidMobileNumber");
        }

        if (isIndia && targetDigits.length !== 10) {
            return t("form.invalidMobileNumber");
        }

        return true;
    };

    const [otpSentMessage, setOtpSentMessage] = useState("");
    const [otpSentSuccessfully, setOtpSentSuccessfully] = useState(false);
    const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
    const [otpEnablementSecRemaining, setOtpEnablementSecRemaining] =
        useState(15);
    const [otpTimer, setOtpTimer] = useState(false); // OTP countdown timer for enable/disable
    const [hasRequestedOtpOnce, setHasRequestedOtpOnce] = useState(false); // Tracks if user has requested OTP at least once
    const [mobileAlreadySubmitted, setMobileAlreadySubmitted] = useState(false);
    const RenderGenerateOTP = () => {
        useEffect(() => {
            if (!otpTimer) return;
            let intervalId = null;
            if (otpButtonDisabled) {
                intervalId = setInterval(() => {
                    setOtpEnablementSecRemaining(
                        (prevSeconds) => prevSeconds - 1,
                    );
                }, 1000);
            }
            return () => {
                if (intervalId) clearInterval(intervalId);
            };
        }, [otpButtonDisabled]);
        useEffect(() => {
            if (otpEnablementSecRemaining <= 0) {
                setOtpButtonDisabled(false);
                setOtpEnablementSecRemaining(15);
            }
        }, []); // [otpEnablementSecRemaining]

        // Check if this number already submitted feedback; if not (or API fails), send OTP.
        const checkSubmittedThen = (onOkToSendOtp) => {
            axios
                .post("/fbs/public/check-submitted", {
                    org_id: template?.org_id,
                    phone: watch("uMob"),
                })
                .then((r) => {
                    if (r.data?.already_submitted) {
                        setMobileAlreadySubmitted(true);
                        setOtpSentMessage(t("otp.alreadySubmitted"));
                        return;
                    }
                    setMobileAlreadySubmitted(false);
                    onOkToSendOtp();
                })
                .catch(() => {
                    setMobileAlreadySubmitted(false);
                    onOkToSendOtp(); // e.g. 404 when backend not deployed yet
                });
        };

        const generateAndSendOTP = () => {
            if (!watch("uMob") || watch("uMob")?.length < 10) {
                /* 10 is random; To account for +1 5003299 etc. too */
                setOtpSentMessage(`✖ ${t("form.invalidMobileNumber")}`);
                return;
            }
            setOtpSentSuccessfully(false);
            setOtpValidationMessage("");
            setValue("otp", ""); // Clear the OTP input field when resending
            setOtpSentMessage("");

            checkSubmittedThen(() => {
                axios
                    .post("/user-otps/generate-otp", {
                        org_id: template?.org_id,
                        phone: watch("uMob"),
                    })
                    .then((r) => {
                        console.log("Feedback Code Generated and sent");
                        setOtpSentMessage(t("otp.sent"));
                        setOtpSentSuccessfully(true);
                        if (!hasRequestedOtpOnce) setHasRequestedOtpOnce(true); // Switch button label to "Resend Code" only after a successful OTP send
                        setOtpButtonDisabled(true);
                        if (!otpTimer)
                            setTimeout(() => setOtpButtonDisabled(false), 750); // Prevents multiple clicks (rudimentary)
                    })
                    .catch((e) => {
                        console.log("Feedback Code Generation Error");
                        setOtpSentSuccessfully(true);
                        setOtpButtonDisabled(false);
                    });
            });
        };
        return (
            <Button
                onClick={generateAndSendOTP}
                modifier="large--cta"
                className={`button-otp ${hasRequestedOtpOnce ? "button-otp-resend theme-color theme-primary-bg" : "button-otp-send theme-color theme-secondary-bg"}`}
                style={{ minWidth: 125 }}
                disabled={
                    !isFormReady || otpButtonDisabled || mobileAlreadySubmitted
                }
            >
                {hasRequestedOtpOnce
                    ? t("action.resendCode")
                    : t("action.sendCode")}{" "}
                {otpButtonDisabled && otpTimer && (
                    <span>({otpEnablementSecRemaining})</span>
                )}
            </Button>
        );
    };

    const [otpValidated, setOtpValidated] = useState(false);
    const [otpValidationMessage, setOtpValidationMessage] = useState("");
    const RenderOTPValidator = () => {
        const validateOTP = () => {
            axios
                .post("/user-otps/validate-otp", {
                    org_id: template?.org_id,
                    phone: watch("uMob"),
                    otp: watch("otp"),
                })
                .then((r) => {
                    setOtpValidated(true);
                    setOtpValidationMessage(t("otp.validated"));
                })
                .catch((e) => {
                    setOtpValidated(false);
                    setOtpValidationMessage(t("otp.validationError"));
                });
        };

        const otpMandatoryCondition =
            (config_shouldValidateOtp && watch("uMob")) ?? false;

        return (
            <div style={{ position: "relative" }}>
                <small className="fbs-form-input-label">
                    {t("form.feedbackCode")}{" "}
                    {otpMandatoryCondition ? (
                        <em className="form-required">*</em>
                    ) : (
                        <></>
                    )}
                </small>
                <input
                    name="otp"
                    type="number"
                    className="fbs-form-input fbs-form-text-input"
                    placeholder={t("form.enterFeedbackCode")}
                    {...register("otp", {
                        required: otpMandatoryCondition,
                        minLength: 4,
                        maxLength: 6,
                    })}
                />
                {errors?.otp && (
                    <span className="error-inline">
                        {t("form.validateFeedbackCode")}
                    </span>
                )}

                <div className="otp-validate-btn-container">
                    <Button
                        onClick={validateOTP}
                        modifier="large--cta"
                        className="button-otp button-otp-validate theme-color theme-secondary-bg"
                        style={{ minWidth: 125 }}
                        disabled={!isFormReady || !otpSentSuccessfully}
                    >
                        {t("action.validateCode")}
                    </Button>
                </div>

                {/* OTP Validation message */}
                {otpValidationMessage && (
                    <span
                        className={
                            otpValidated ? "success-inline" : "error-inline"
                        }
                    >
                        {otpValidationMessage}
                    </span>
                )}
            </div>
        );
    };

    /* Reset OTP state to defaults (after success) */
    const resetOTPState = () => {
        setOtpSentMessage("");
        setOtpSentSuccessfully(false);
        setOtpButtonDisabled(false);
        setOtpEnablementSecRemaining(15);
        setOtpValidated(false);
        setOtpValidationMessage("");
    };

    const RenderTncHtml = () => {
        const handleChange = (e) => {
            console.log("TnC checked", e.target.checked);
        };

        return (
            <div style={{ width: "100%", paddingTop: "10px" }}>
                <p
                    dangerouslySetInnerHTML={{ __html: config_tnc }}
                    className="open-links-in-new-tab"
                />
                <label className="tnc-label">
                    <input
                        type="checkbox"
                        {...register("tncCheck", { required: true })}
                    />{" "}
                    {t("tnc.agree")}
                </label>
                {errors?.tncCheck && (
                    <span className="error-inline">{t("tnc.required")}</span>
                )}
            </div>
        );
    };

    const RenderPrivacyHtml = () => {
        return (
            <div style={{ width: "100%", paddingTop: "10px" }}>
                <p
                    dangerouslySetInnerHTML={{ __html: config_privacy }}
                    className="open-links-in-new-tab"
                />
            </div>
        );
    };

    const RenderFeedbackForm = () => {
        /* References */
        return (
            <div
                style={{ width: "100%", paddingTop: "10px" }}
                className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
            >
                <form
                    className="fbs-form fbs-submit-form bg-glass"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <div className="fbs-form-section-sub">
                        <h3
                            className="theme-color theme-primary"
                            style={
                                isOmanTheme
                                    ? { fontSize: "3rem", lineHeight: 1.2 }
                                    : undefined
                            }
                        >
                            {/*{getRatingHeadingText()}*/}
                            {t("screen.weWouldLoveToHear")}{" "}
                            {/* Changed to static; for Encalm Req */}
                        </h3>
                        {/* Comment */}
                        <div className="feedback-text">
                            {audioFeedback ? (
                                <small className="fbs-form-input-label">
                                    {t(
                                        "form.feedbackSuggestionsPreferredLanguage",
                                    )}{" "}
                                    <em>{t("form.optional")}</em>
                                </small>
                            ) : (
                                <small
                                    className="fbs-form-input-label"
                                    style={
                                        isOmanTheme
                                            ? { fontSize: "2rem" }
                                            : undefined
                                    }
                                >
                                    {t("form.feedbackSuggestions")}{" "}
                                    <em>{t("form.optional")}</em>
                                </small>
                            )}
                            {config_audio_feedback === "true" ? (
                                <span className="audio-toggle">
                                    {"   "}
                                    <Switch
                                        checked={audioFeedback}
                                        onChange={() =>
                                            setAudioFeedback(!audioFeedback)
                                        }
                                    />
                                    <span>{t("form.audioFeedback")}</span>
                                </span>
                            ) : (
                                <></>
                            )}
                        </div>
                        {audioFeedback ? (
                            <div id="audio-feedback">
                                <NewAudioRecorder
                                    setAudioBlob={setAudioBlob}
                                    audioBlob={audioBlob}
                                    setIsFormReady={setIsFormReady}
                                />
                            </div>
                        ) : (
                            <>
                                <textarea
                                    name="text"
                                    id=""
                                    rows="2"
                                    className="fbs-form-input fbs-form-textarea isAnimated"
                                    placeholder={t("form.feedbackPlaceholder")}
                                    style={
                                        isOmanTheme
                                            ? { fontSize: "1rem" }
                                            : undefined
                                    }
                                    {...register("text", {
                                        required: false,
                                        minLength: 0,
                                        maxLength: 2048,
                                    })}
                                />
                                {errors?.text && (
                                    <span className="error-inline">
                                        {t("form.minimumCharacters")}
                                    </span>
                                )}
                            </>
                        )}
                        {/* Airline Name [Optional/Conditionally rendered] */}
                        {(template?.meta?.airline ?? false) && (
                            <div style={{ position: "relative" }}>
                                <small className="fbs-form-input-label">
                                    {t("form.pleaseSelectAirline")}{" "}
                                    {(template?.meta?.airlineMan ?? false) ? (
                                        <em className="form-required">*</em>
                                    ) : (
                                        <em>{t("form.optional")}</em>
                                    )}{" "}
                                </small>
                                <Controller
                                    name="airlineObj"
                                    control={control}
                                    rules={{
                                        required:
                                            template?.meta?.airlineMan ?? false,
                                    }}
                                    defaultValue={null}
                                    render={({
                                        field: { onChange, value },
                                        fieldState: { error },
                                    }) => (
                                        <Autocomplete
                                            options={airlinesOptions}
                                            getOptionLabel={(option) =>
                                                option?.name || ""
                                            }
                                            isOptionEqualToValue={(
                                                option,
                                                value,
                                            ) => option?.value === value?.value}
                                            value={value}
                                            onChange={(event, newValue) =>
                                                onChange(newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder={t(
                                                        "form.selectAirline",
                                                    )}
                                                    fullWidth
                                                    error={!!error}
                                                    helperText={error?.message}
                                                    sx={{
                                                        "& .MuiInputBase-root":
                                                            {
                                                                backgroundColor:
                                                                    "rgba(0, 0, 0, 0.1)",
                                                                border: "none",
                                                                paddingRight:
                                                                    "8px", // for dropdown icon spacing
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                            },
                                                        "& .MuiOutlinedInput-notchedOutline":
                                                            {
                                                                border: "none",
                                                            },
                                                        "& .MuiInputLabel-root":
                                                            {
                                                                top: "-6px",
                                                            },
                                                        "& .MuiAutocomplete-input":
                                                            {
                                                                padding:
                                                                    "0px 6px",
                                                                height: "auto",
                                                            },
                                                    }}
                                                />
                                            )}
                                            sx={{ mb: 4 }}
                                        />
                                    )}
                                />
                            </div>
                        )}

                        {/* User's Name */}
                        {(template?.meta?.uName ?? false) && (
                            <div>
                                <small className="fbs-form-input-label">
                                    {t("form.yourName")}{" "}
                                    {(template?.meta?.uNameMan ?? false) ? (
                                        <em className="form-required">*</em>
                                    ) : (
                                        <em>{t("form.optional")}</em>
                                    )}
                                </small>
                                <input
                                    name="name"
                                    type="text"
                                    className="fbs-form-input fbs-form-text-input"
                                    {...register("uName", {
                                        required:
                                            template?.meta?.uNameMan ?? false,
                                        maxLength: 96,
                                        minLength: 3,
                                        pattern: /^[a-zA-Z.' ]+$/,
                                    })}
                                />
                                {errors?.uName?.type === "required" && (
                                    <span className="error-inline">
                                        {t("form.nameRequired")}
                                    </span>
                                )}
                                {(errors?.uName?.type === "pattern" ||
                                    errors?.uName?.type === "minLength") && (
                                    <span className="error-inline">
                                        {t("form.invalidName")}
                                    </span>
                                )}
                                {isBialOrg && (
                                    <p className="info-inline">
                                        {t("form.bialInfo")}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Contact [Optional/Conditionally rendered] */}
                        {(template?.meta?.uMob ?? false) && (
                            <div
                                style={{
                                    position: "relative",
                                    marginTop:
                                        (template?.meta?.uName ?? false)
                                            ? 20
                                            : 0,
                                }}
                            >
                                <small className="fbs-form-input-label">
                                    {t("form.yourContactNumber")}{" "}
                                    {(template?.meta?.uMobMan ?? false) ? (
                                        <em className="form-required">*</em>
                                    ) : (
                                        <em>{t("form.optional")}</em>
                                    )}{" "}
                                </small>
                                <Controller
                                    name="uMob"
                                    control={control}
                                    rules={{
                                        required:
                                            (template?.meta?.uMobMan ?? false)
                                                ? t("form.mobileRequired")
                                                : false,
                                        validate: (value) =>
                                            validateMobileNumber(
                                                value,
                                                template?.meta?.uMobMan ??
                                                    false,
                                            ),
                                    }}
                                    render={({
                                        field: {
                                            onChange,
                                            value,
                                            formattedValue,
                                        },
                                    }) => (
                                        <PhoneInput
                                            id="uMob"
                                            inputStyle={{
                                                background: "rgb(0,0,0,0.1)",
                                                border: "none",
                                                height: "50px",
                                                width: "100%",
                                            }}
                                            containerStyle={{
                                                border: "none",
                                                height: "50px",
                                            }}
                                            value={formattedValue}
                                            onChange={(
                                                value,
                                                country,
                                                e,
                                                formattedValue,
                                            ) => {
                                                setMobileAlreadySubmitted(
                                                    false,
                                                );
                                                if (
                                                    country?.dialCode ===
                                                        value ||
                                                    "+" === country?.dialCode
                                                ) {
                                                    return onChange("");
                                                } else {
                                                    return onChange(
                                                        formattedValue,
                                                    );
                                                }
                                            }}
                                            placeholder={t(
                                                "form.enterMobileNumber",
                                            )}
                                            enableSearch={true}
                                            searchPlaceholder={t(
                                                "form.searchCountry",
                                            )}
                                            disableSearchIcon={true}
                                            country="in"
                                            preferredCountries={[
                                                "in",
                                                "us",
                                                "gb",
                                                "sg",
                                                "au",
                                            ]}
                                            excludeCountries={[""]}
                                            disabled={otpValidated}
                                        />
                                    )}
                                />

                                {/* ================= OTP ================= */}
                                {/* OTP message */}
                                {otpSentMessage && (
                                    <span
                                        className={
                                            otpSentSuccessfully
                                                ? "success-inline"
                                                : "error-inline"
                                        }
                                    >
                                        {otpSentMessage}
                                    </span>
                                )}
                                {/* OTP Validation UI */}
                                {config_shouldValidateOtp ? (
                                    <div className="otp-verify-btn-container">
                                        <RenderGenerateOTP />
                                    </div>
                                ) : (
                                    <></>
                                )}
                                {/* ================= /OTP ================= */}
                            </div>
                        )}

                        {/* <input type="number" className="fbs-form-input isAnimated" placeholder=""
                               {...register("uMob", {required:false, minLength:10, maxLength:20})}
                        /> */}
                        {errors?.uMob && (
                            <span className="error-inline">
                                {errors?.uMob?.message ??
                                    t("form.invalidMobileNumber")}
                            </span>
                        )}
                    </div>

                    {/* ================= OTP ================= */}
                    {config_shouldValidateOtp ? <RenderOTPValidator /> : <></>}
                    {/* ================= /OTP ================= */}

                    {/* Email [Optional/Conditionally rendered] */}
                    {(template?.meta?.uEmail ?? false) && (
                        <div className="fbs-form-section-sub">
                            <div>
                                <small className="fbs-form-input-label">
                                    {t("form.yourEmailId")}{" "}
                                    {(template?.meta?.uEmailMan ?? false) ? (
                                        <em className="form-required">*</em>
                                    ) : (
                                        <em>{t("form.optional")}</em>
                                    )}
                                </small>
                                <input
                                    name="name"
                                    type="text"
                                    className="fbs-form-input fbs-form-text-input"
                                    {...register("uEmail", {
                                        required:
                                            template?.meta?.uEmailMan ?? false,
                                        maxLength: 96,
                                        pattern: /^\S+@\S+$/i,
                                    })}
                                />
                                {errors?.uEmail?.type === "required" && (
                                    <span className="error-inline">
                                        {t("form.emailRequired")}
                                    </span>
                                )}
                                {errors?.uEmail?.type === "pattern" && (
                                    <span className="error-inline">
                                        {t("form.invalidEmail")}
                                    </span>
                                )}
                            </div>
                        </div>
                    )}

                    {/*Org Name*/}
                    {
                        <div className="fbs-form-section-sub">
                            <div className="fbs-grid">
                                {(template?.meta?.orgName ?? false) && (
                                    <div>
                                        <small className="fbs-form-input-label">
                                            {t("form.organizationName")}{" "}
                                            {(template?.meta?.orgNameMan ??
                                            false) ? (
                                                <em className="form-required">
                                                    *
                                                </em>
                                            ) : (
                                                <em>{t("form.optional")}</em>
                                            )}
                                        </small>
                                        <input
                                            name="name"
                                            type="text"
                                            className="fbs-form-input fbs-form-text-input"
                                            {...register("orgName", {
                                                required:
                                                    template?.meta
                                                        ?.orgNameMan ?? false,
                                            })}
                                        />
                                        {errors?.orgName?.type ===
                                            "required" && (
                                            <span className="error-inline">
                                                {t("form.orgNameRequired")}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                    {/* TnC */}
                    {config_tnc !== null ? <RenderTncHtml /> : <></>}

                    <div
                        className="fbs-form-section-sub"
                        style={{ marginTop: 30 }}
                    >
                        {/* Button1 */}
                        {/* <Button type="submit" id="fbs-give-more" onClick={handleSubmit(onSubmit)} modifier="large--cta" className="theme-color theme-secondary-bg" disabled={!isFormReady}>
                            Give more feedback
                        </Button> */}

                        {/* Hide 'Give Additional feedback' button for organizational feedback */}
                        {!orgRatingData && !isBialOrg && (
                            <a
                                href="#"
                                id="fbs-give-more"
                                onClick={
                                    isFormReady
                                        ? handleSubmit(onSubmit)
                                        : (e) => e.preventDefault()
                                }
                                style={{
                                    pointerEvents: !isFormReady
                                        ? "none"
                                        : "auto",
                                    opacity: !isFormReady ? 0.5 : 1,
                                }}
                                disabled={!isFormReady}
                            >
                                {t("action.giveAdditionalFeedback")}
                            </a>
                        )}

                        <div style={{ marginTop: "20px" }}>
                            {/* Button2 */}
                            <Button
                                type="submit"
                                id="fbs-main-submit"
                                modifier="large--cta"
                                onClick={handleSubmit(onSubmit)}
                                className="theme-color theme-primary-bg"
                                disabled={!isFormReady}
                            >
                                {t("action.submitFeedback")}
                            </Button>
                        </div>
                    </div>
                    {/* Privacy Policy */}
                    {config_privacy !== null ? <RenderPrivacyHtml /> : <></>}
                </form>
            </div>
        );
    };

    // Get logo: Encalm template asset → URL theme asset (Oman) → org API logo
    const getLogoUrl = () => {
        const orgId = template?.org_id ?? template?.org?.id;
        const orgName = (template?.org?.name ?? "").toLowerCase();

        // Template ID 151 with Encalm org -> use Encalm RDC logo from assets
        if (
            template?.id === 151 &&
            (orgName.includes("encalm") || orgId === 1071)
        ) {
            return encalmRDCLogo;
        }

        const urlThemeLogo = getUrlThemeLogoAsset();
        if (urlThemeLogo) return urlThemeLogo;

        return template?.org?.logo_img ?? "";
    };

    // Navigate to feedback form for org rating
    const navigateToFeedbackForm = (feedbackData) => {
        setOrgRatingData(feedbackData); // Store the org rating data for later use in onSubmit
        setRating(feedbackData.rating); // Set the average rating for the main flow
        delayedLoadView(PAGE_INDEX.FEEDBACK);
    };

    // Render org rating view when viewIndex is 0 and org_rating is enabled
    if (template?.org_rating === true && viewIndex === 0 && !showThankYou) {
        return (
            <div
                className={`ratings-container`}
                dir={selectedLanguageDirection}
                aria-busy={isSubmittingFeedback}
            >
                <RenderHeader logo={getLogoUrl()} />
                {config_enable_translations &&
                    supportedLanguages.length > 1 && (
                        <div
                            id="fbs-language-selector-org"
                            style={{
                                position: "absolute",
                                top: isMobile ? 88 : 96,
                                right: 20,
                                zIndex: 120,
                                background: "rgba(255,255,255,0.92)",
                                borderRadius: 12,
                                padding: "10px 12px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                            }}
                        >
                            <label
                                htmlFor="fbs-language-selector-org"
                                style={{
                                    display: "block",
                                    fontSize: 12,
                                    marginBottom: 4,
                                }}
                            >
                                {t("action.language")}
                            </label>
                            <select
                                id="fbs-language-selector-org"
                                value={resolvedLanguage}
                                onChange={(event) =>
                                    setSelectedLanguage(event.target.value)
                                }
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    fontSize: 15,
                                }}
                            >
                                {supportedLanguages.map((language) => (
                                    <option
                                        key={language.key}
                                        value={language.key}
                                    >
                                        {language.label} -{" "}
                                        {language.nativeLabel}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                <div
                    className={`animate__animated ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                >
                    <FbsOrgLanding
                        template={template}
                        bgImage={bgImage}
                        onNavigateToFeedback={navigateToFeedbackForm}
                        categoryRatings={orgCategoryRatings}
                        setCategoryRatings={setOrgCategoryRatings}
                        categoryIssues={orgCategoryIssues}
                        setCategoryIssues={setOrgCategoryIssues}
                        selectedLanguage={resolvedLanguage}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            className={`ratings-container`}
            dir={selectedLanguageDirection}
            aria-busy={isSubmittingFeedback}
        >
            <RenderHeader logo={getLogoUrl()} />

            {config_enable_translations && supportedLanguages.length > 1 && (
                <div
                    id="fbs-language-selector"
                    style={{
                        position: "absolute",
                        top: isMobile ? 48 : 56,
                        right: 26,
                        zIndex: 120,
                        background: "rgba(255,255,255,0.92)",
                        borderRadius: 12,
                        padding: "10px 12px",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    }}
                >
                    <label
                        htmlFor="fbs-language-selector"
                        style={{
                            display: "block",
                            fontSize: 12,
                            marginBottom: 4,
                        }}
                    >
                        {t("action.language")}
                    </label>
                    <select
                        id="fbs-language-selector"
                        value={resolvedLanguage}
                        onChange={(event) =>
                            setSelectedLanguage(event.target.value)
                        }
                        style={{
                            border: "none",
                            background: "transparent",
                            fontSize: 15,
                        }}
                    >
                        {supportedLanguages.map((language) => (
                            <option key={language.key} value={language.key}>
                                {language.label} - {language.nativeLabel}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {/* Show staff tile when a staff is assigned OR when switching is enabled */}
            {assocStaff?.id || staffSwitchEnabled ? (
                (() => {
                    const staffOnDutyLabel = staffOnDutyFirstName(assocStaff);
                    const shiftDisplayName = assocShift?.name ?? "";
                    const staffTitle = shiftDisplayName
                        ? `${staffOnDutyLabel} @ ${shiftDisplayName}`
                        : staffOnDutyLabel;
                    return (
                <div
                    className={`fbs-staff-on-duty__rating ${isMobile ? "fbs-staff-on-duty__isMobile" : ""}`}
                    title={staffTitle}
                    onClick={() => {
                        if (staffSwitchEnabled) setStaffSwitcherOpen(true);
                    }}
                    style={staffSwitchEnabled ? { cursor: "pointer" } : {}}
                >
                    <div
                        className={
                            staffSwitchEnabled
                                ? "fbs-staff-switchable-indicator"
                                : ""
                        }
                    >
                        <img
                            src={assocStaff?.avatar ?? PROFILE_IMG_FALLBACK}
                            alt="Staff"
                            className="fbs-loc-staff-profile-img fbs-loc-staff-profile-img-rating"
                            style={
                                isOmanTheme ? { border: "none" } : undefined
                            }
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = PROFILE_IMG_FALLBACK;
                            }}
                        />
                    </div>
                    <h6 className="fbs-staff-on-duty__rating-header">
                        {staffOnDutyLabel}
                    </h6>
                </div>
                    );
                })()
            ) : (
                <></>
            )}

            <div
                className={`flex flex-both-center flex-dir-col ${isTransitioning ? "is-transitioning" : ""}`}
            >
                {/* Ratings */}
                {viewIndex === PAGE_INDEX.RATING && (
                    <div
                        className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                    >
                        <h3
                            className="theme-color theme-primary fbs-rating-heading"
                            style={
                                isOmanTheme
                                    ? { fontSize: "2rem", lineHeight: 1.2 }
                                    : undefined
                            }
                        >
                            <span
                                style={
                                    isOmanTheme
                                        ? {
                                              fontSize: "3rem",
                                              lineHeight: 1.2,
                                              display: "inline-block",
                                          }
                                        : undefined
                                }
                            >
                                {t("screen.rateExperience")}
                            </span>
                            {!config_hide_location &&
                                template?.org_id !== 1071 && (
                                    <small
                                        className="d-b p-t-b-10 fbs-header-location col-dark opa-050"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 8,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        <span>
                                            {getLocationIcon()}{" "}
                                            {template?.location?.location ??
                                                fbsMeta?.location?.location ??
                                                getLocationNameLS()}
                                        </span>
                                        {config_show_average_rating &&
                                            isTablet &&
                                            template?.location?.meta
                                                ?.avg_rating != null && (
                                                <span
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "baseline",
                                                        gap: 6,
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            opacity: 0.35,
                                                            fontWeight: 300,
                                                            paddingRight: 3,
                                                            paddingLeft: 8,
                                                        }}
                                                    >
                                                        |
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: 700,
                                                            color: "#f5900a",
                                                        }}
                                                    >
                                                        {"★ "}
                                                        {Number(
                                                            template.location
                                                                .meta
                                                                .avg_rating,
                                                        ).toFixed(1)}
                                                        <span
                                                            style={{
                                                                fontWeight: 400,
                                                            }}
                                                        >
                                                            /5
                                                        </span>
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontSize: "0.75em",
                                                            fontWeight: 400,
                                                            opacity: 0.86,
                                                        }}
                                                    >
                                                        {template.location.meta
                                                            .total_ratings
                                                            ? `(${template.location.meta.total_ratings} ${t("label.ratingsCount")})`
                                                            : ""}
                                                    </span>
                                                </span>
                                            )}
                                    </small>
                                )}
                        </h3>
                        <div className="fbs-rating-blocks fbs-ratings-main">
                            {activeRatingTheme?.ratings?.map((r, rIndex) => {
                                return (
                                    <label
                                        key={rIndex}
                                        htmlFor={"rating-" + rIndex}
                                        className={`${ratingIndex === rIndex ? "isSelected theme-color theme-primary" : ""}`}
                                    >
                                        <div
                                            className={`fbs-rating-${r?.score ?? 0} fbs-rating-block app-shadow-default animate__animated`}
                                            tabIndex={1}
                                        >
                                            {activeRatingTheme.animated ? (
                                                <Lottie
                                                    animationData={r.img}
                                                    loop={true}
                                                    className="fbs-rating-animation"
                                                />
                                            ) : (
                                                <img
                                                    src={r.img}
                                                    alt={r.name}
                                                    className="fbs-rating-img"
                                                />
                                            )}
                                            <input
                                                type="radio"
                                                name="radio"
                                                value={rIndex}
                                                onClick={() => {
                                                    setTheRating(r.score);
                                                    setTheRatingIndex(rIndex);
                                                    navigateStepWithRating(
                                                        +1,
                                                        r.score,
                                                    );
                                                }}
                                                id={"rating-" + rIndex}
                                                style={{ display: "none" }}
                                            />
                                            <span className="fbs-rating-title">
                                                {resolveRatingOptionText(
                                                    r.name,
                                                    r.nameKey,
                                                    resolvedLanguage,
                                                )}
                                            </span>
                                        </div>
                                    </label>
                                );
                            })}
                        </div>

                        {/* Oman theme: QR block below smileys */}
                        {isOmanTheme && (
                            <div className="qr-strip-fbs-rating-page">
                                <div className="qr-strip-fbs-rating-page__left">
                                    <div className="qr-strip-fbs-rating-page__qr">
                                        {isOmanTheme && isTablet ? (
                                            <QRCode
                                                value={_qrPrepend + _qrText}
                                                size={142}
                                                bgColor={"#ffffff"}
                                                fgColor={"#000000"}
                                                level={"L"}
                                                includeMargin={false}
                                                renderAs={"svg"}
                                            />
                                        ) : (
                                            <a
                                                href={_qrPrepend + _qrText}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <QRCode
                                                    value={_qrPrepend + _qrText}
                                                    size={142}
                                                    bgColor={"#ffffff"}
                                                    fgColor={"#000000"}
                                                    level={"L"}
                                                    includeMargin={false}
                                                    renderAs={"svg"}
                                                />
                                            </a>
                                        )}
                                    </div>
                                    <div className="qr-strip-fbs-rating-page__text">
                                        {t("screen.qrHelperText")}
                                    </div>
                                </div>
                                {/* Oman tablet: tap logo/text here to open the logout modal (replaces the hidden power-off icon) */}
                                {isTablet ? (
                                    <button
                                        type="button"
                                        className="qr-strip-fbs-rating-page__brand qr-strip-fbs-rating-page__brand--vesta"
                                        onClick={() => setOmanLogoutOpen(true)}
                                        style={{
                                            cursor: "pointer",
                                            background: "none",
                                            border: "none",
                                            padding: 0,
                                            userSelect: "none",
                                            WebkitUserSelect: "none",
                                            WebkitTapHighlightColor: "transparent",
                                            WebkitTouchCallout: "none",
                                        }}
                                    >
                                        <img src={vesta32Logo} alt="Vesta" />
                                        <span>{t("screen.poweredByVesta")}</span>
                                    </button>
                                ) : (
                                    <div className="qr-strip-fbs-rating-page__brand qr-strip-fbs-rating-page__brand--vesta">
                                        <img src={vesta32Logo} alt="Vesta" />
                                        <span>{t("screen.poweredByVesta")}</span>
                                    </div>
                                )}
                                <div className="qr-strip-fbs-rating-page__brand qr-strip-fbs-rating-page__brand--sada">
                                    <img src={omanSadaLogo} alt="SADA" />
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Section (Issue Category) */}
                {viewIndex === PAGE_INDEX.SECTION && (
                    <div
                        className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                        style={{ width: "100%", padding: "20px" }}
                    >
                        <h3 className="theme-color theme-primary fbs-header-issue-section">
                            {getRatingSectionText()}
                        </h3>
                        <div
                            className="fbs-rating-blocks fbs-items"
                            style={{ color: config_items_color }}
                        >
                            {template?.content?.sections?.map(
                                (section, mainSectionIndex) => {
                                    return (
                                        <div
                                            key={mainSectionIndex}
                                            onClick={() => {
                                                setSectionIndex(
                                                    mainSectionIndex,
                                                );
                                                navigateStep(
                                                    +1,
                                                    viewIndex,
                                                    mainSectionIndex,
                                                );
                                            }}
                                            className={`fbs-rating-block fbs-item ${mainSectionIndex === stateSectionIndex ? "isSelected theme-color theme-primary" : ""}`}
                                        >
                                            <Icon
                                                icon={section?.icon}
                                                width={config.iconifyIconSize}
                                                height={config.iconifyIconSize}
                                                className="fbs-rating-img"
                                            />
                                            <strong className="fbs-rating-title">
                                                {tl(section)}
                                            </strong>
                                        </div>
                                    );
                                },
                            )}
                        </div>
                    </div>
                )}

                {/* Subsections (Sub-issue) */}
                {viewIndex === PAGE_INDEX.SUBSECTION && (
                    <div
                        className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                        style={{ width: "100%" }}
                    >
                        <h3 className="theme-color theme-primary fbs-header-issue-section-sub">
                            {getRatingSubSectionText()}
                        </h3>
                        <div
                            className="fbs-rating-blocks fbs-items"
                            style={{ color: config_items_color }}
                        >
                            {template?.content?.sections?.map(
                                (section, mainSectionIndex) => {
                                    return mainSectionIndex ===
                                        stateSectionIndex ? (
                                        <React.Fragment key={mainSectionIndex}>
                                            {section?.sections?.map(
                                                (
                                                    subSection,
                                                    subSectionIndex,
                                                ) => {
                                                    return (
                                                        <div
                                                            key={
                                                                subSectionIndex
                                                            }
                                                            className={`fbs-rating-block fbs-item ${stateSubSectionIndex === subSectionIndex ? "isSelected theme-color theme-primary" : ""}`}
                                                            onClick={() => {
                                                                setSubSectionIndex(
                                                                    subSectionIndex,
                                                                );
                                                                navigateStep(
                                                                    +1,
                                                                );
                                                            }}
                                                        >
                                                            <Icon
                                                                icon={
                                                                    subSection?.icon
                                                                }
                                                                width={
                                                                    config.iconifyIconSize
                                                                }
                                                                height={
                                                                    config.iconifyIconSize
                                                                }
                                                                className="fbs-rating-img"
                                                            />
                                                            <strong className="fbs-rating-title">
                                                                {tl(subSection)}
                                                            </strong>
                                                        </div>
                                                    );
                                                },
                                            )}
                                        </React.Fragment>
                                    ) : null;
                                },
                            )}
                        </div>
                    </div>
                )}

                {/* SectionPositive (Delighter Category) */}
                {viewIndex === PAGE_INDEX.SECTION_POSITIVE && (
                    <div
                        className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                        style={{ width: "100%" }}
                    >
                        <h3 className="theme-color theme-primary fbs-header-issue-section">
                            {getDelighterSectionText()}
                        </h3>
                        <div
                            className="fbs-rating-blocks fbs-items"
                            style={{ color: config_items_color }}
                        >
                            {template?.content?.sectionsPositive?.map(
                                (section, mainSectionIndex) => {
                                    return (
                                        <div
                                            key={mainSectionIndex}
                                            onClick={() => {
                                                setSectionPosIndex(
                                                    mainSectionIndex,
                                                );
                                                navigateStep(
                                                    +1,
                                                    viewIndex,
                                                    null,
                                                    rating,
                                                    mainSectionIndex,
                                                );
                                            }}
                                            className={`fbs-rating-block fbs-item ${mainSectionIndex === stateSectionPosIndex ? "isSelected theme-color theme-primary" : ""}`}
                                        >
                                            <Icon
                                                icon={section?.icon}
                                                width={config.iconifyIconSize}
                                                height={config.iconifyIconSize}
                                                className="fbs-rating-img"
                                            />
                                            <strong className="fbs-rating-title">
                                                {tl(section)}
                                            </strong>
                                        </div>
                                    );
                                },
                            )}
                        </div>
                    </div>
                )}

                {/* Subsections (Sub-delighter) */}
                {viewIndex === PAGE_INDEX.SUBSECTION_POSITIVE && (
                    <div
                        className={`animate__animated text-a-center ${isGoingBack ? "animate__slideInLeft" : "animate__slideInRight"}`}
                        style={{ width: "100%" }}
                    >
                        <h3 className="theme-color theme-primary fbs-header-issue-section-sub">
                            {getDelighterSubSectionText()}
                        </h3>
                        <div
                            className="fbs-rating-blocks fbs-items"
                            style={{ color: config_items_color }}
                        >
                            {template?.content?.sectionsPositive?.map(
                                (section, mainSectionIndex) => {
                                    return mainSectionIndex ===
                                        stateSectionPosIndex ? (
                                        <React.Fragment key={mainSectionIndex}>
                                            {section?.sections?.map(
                                                (
                                                    subSection,
                                                    subSectionIndex,
                                                ) => {
                                                    return (
                                                        <div
                                                            key={
                                                                subSectionIndex
                                                            }
                                                            className={`fbs-rating-block fbs-item ${stateSubSectionPosIndex === subSectionIndex ? "isSelected theme-color theme-primary" : ""}`}
                                                            onClick={() => {
                                                                setSubSectionPosIndex(
                                                                    subSectionIndex,
                                                                );
                                                                navigateStep(
                                                                    +1,
                                                                );
                                                            }}
                                                        >
                                                            <Icon
                                                                icon={
                                                                    subSection?.icon
                                                                }
                                                                width={
                                                                    config.iconifyIconSize
                                                                }
                                                                height={
                                                                    config.iconifyIconSize
                                                                }
                                                                className="fbs-rating-img"
                                                            />
                                                            <strong className="fbs-rating-title">
                                                                {tl(subSection)}
                                                            </strong>
                                                        </div>
                                                    );
                                                },
                                            )}
                                        </React.Fragment>
                                    ) : null;
                                },
                            )}
                        </div>
                    </div>
                )}

                {/* Feedback Form */}
                {viewIndex === PAGE_INDEX.FEEDBACK && RenderFeedbackForm()}

                {/* Global */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "20px 0",
                        width: "100%",
                    }}
                >
                    {viewIndex !== 0 && (
                        <div
                            className="cur-pointer theme-color theme-primary button-go-back"
                            style={{ zIndex: 999 }}
                            onClick={() => navigateStep(-1)}
                        >
                            <Icon
                                icon="material-symbols:arrow-back-rounded"
                                width={36}
                                height={36}
                            />
                        </div>
                    )}
                    <div>{/* RHS */}</div>
                </div>

                {showEnticer && (
                    <div
                        className={`animate__animated animate__zoomIn cur-pointer bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            position: "absolute",
                            top: 0,
                            backgroundImage: `url(${bgImage})`,
                            width: "100%",
                            height: "100vh",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                            overflow: "hidden",
                            zIndex: 101,
                        }}
                        onClick={dismissEnticer}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            {/*<h3 style={{paddingTop: 0 }}>A gift awaits you!</h3>*/}
                            {/*<Lottie animationData={animGiftWaiting} loop={true} style={{width: 400, height: 400, position: "absolute", zIndex: 99, marginTop: -425 }}/>*/}
                            {/*<Lottie animationData={animFbFaces} loop={true} className={`animFace`} />*/}
                            <Lottie
                                animationData={animFloatingFb}
                                loop={true}
                                className={``}
                            />
                            <div
                                style={{
                                    position: "relative",
                                    zIndex: 100,
                                    paddingTop: 30,
                                    paddingBottom: 0,
                                }}
                            >
                                {" "}
                                {/* paddingTop: 150 */}
                                <h3
                                    style={{ margin: 0, paddingBottom: 0 }}
                                    className="theme-color theme-primary"
                                >
                                    {t("screen.helpUsServeBetter")}
                                </h3>
                                <p style={{ color: "#707070" }}>
                                    {t("screen.touchToProvideFeedback")}
                                </p>
                            </div>
                            {/*<Lottie animationData={animAwaitingFeedback} loop={true} style={{width: 640, height: 420, marginTop: -80, zIndex:0 }}/>*/}
                        </div>
                    </div>
                )}

                {showThankYou && (
                    <div
                        className={`animate__animated animate__zoomIn bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            position: "absolute",
                            top: 0,
                            backgroundImage: `url(${bgImage})`,
                            width: "100%",
                            height: "100vh",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                            zIndex: 102,
                        }}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <Lottie
                                animationData={animThankYouStar}
                                loop={true}
                                style={{ width: 230, height: 230 }}
                            />
                            <h3 style={{ paddingTop: 10, marginTop: 0 }}>
                                {t("rating.thankYou")}!
                            </h3>
                            {feedbackID && !hideFeedbackIdOnThankYou && (
                                <span>
                                    {t("modal.feedbackId")}: {feedbackID}
                                </span>
                            )}
                            {/*<div style={{position:'relative', zIndex:100, paddingTop: 150}}>
                    <h3 style={{margin:0, padding: 0 }}>We will get in touch</h3>
                    <p>for details regarding your gift</p>
                </div>*/}
                        </div>
                    </div>
                )}

                {isSubmittingFeedback && (
                    <div
                        className={`animate__animated bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            ...fullScreenOverlayBaseStyle,
                            zIndex: 103,
                        }}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            role="status"
                            aria-live="polite"
                            aria-atomic="true"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <Icon
                                icon="eos-icons:loading"
                                width={52}
                                height={52}
                                aria-hidden="true"
                                style={{ marginBottom: 12 }}
                            />
                            <h4 style={{ marginTop: 0, marginBottom: 8 }}>
                                {t("screen.submittingFeedback")}
                            </h4>
                            <p style={{ margin: 0, color: "#555" }}>
                                {t("screen.pleaseWait")}
                            </p>
                        </div>
                    </div>
                )}

                {/* Render expiration message */}
                {isExpired && (
                    <div
                        className={`animate__animated animate__zoomIn bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            position: "absolute",
                            top: 0,
                            backgroundImage: `url(${bgImage})`,
                            width: "100%",
                            height: "100vh",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                            overflow: "hidden",
                            zIndex: 101,
                        }}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <h4 style={{ marginTop: 0 }}>
                                {t("screen.expired")}
                            </h4>
                        </div>
                    </div>
                )}

                {/* Render missing template message (org-scoped) */}
                {templateMissing && (
                    <div
                        className={`animate__animated animate__zoomIn bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            ...fullScreenOverlayBaseStyle,
                            overflow: "hidden",
                            zIndex: 103,
                        }}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                padding: 16,
                            }}
                        >
                            <div
                                className="fbs-block-prominent"
                                style={{
                                    background: "rgba(255,255,255,0.92)",
                                    padding: "18px 16px",
                                    borderRadius: 14,
                                    maxWidth: 420,
                                    width: "92%",
                                    boxShadow:
                                        "0 10px 40px rgba(0,0,0,0.12)",
                                }}
                            >
                                <h3
                                    style={{
                                        margin: 0,
                                        color: "#111",
                                        textAlign: "center",
                                    }}
                                >
                                    {templateMissingMessage ||
                                        FBS_TEMPLATE_MISSING_MESSAGE}
                                </h3>
                            </div>
                        </div>
                    </div>
                )}

                {/* Blocking Loader: Introduced so that on Mobile ratings, the end user does not see default theme before org API response && custom theme setting */}
                {showBlockingLoader && (
                    <div
                        className={`animate__animated bg-cover theme-bg-img ${isMobile ? "app-container-mobile" : ""}`}
                        style={{
                            position: "absolute",
                            top: 0,
                            backgroundImage: `url(${bgImage})`,
                            width: "100%",
                            height: "100vh",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                            zIndex: 102,
                        }}
                    >
                        <RenderHeader logo={getLogoUrl()} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <h5 style={{ paddingTop: 10, marginTop: 0 }}>
                                {t("screen.loading")}
                            </h5>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            {isTablet && (
                <RenderFooter
                    externalOpen={isOmanTheme ? omanLogoutOpen : undefined}
                    onExternalClose={isOmanTheme ? () => setOmanLogoutOpen(false) : undefined}
                />
            )}

            {/* Staff Switcher Modal */}
            <FbsStaffSwitcher
                isOpen={staffSwitcherOpen}
                onClose={() => setStaffSwitcherOpen(false)}
                orgId={fbsMeta?.org_id}
                locationId={fbsMeta?.location?.id}
                currentStaffId={assocStaff?.id}
                onSwitchSuccess={() => getTheTemplate()}
            />
        </div>
    );
}

export function FbsSetLocation(params) {
    let navigate = useNavigate();
    let user = getStorage("u4");

    /* Get defaults on firstLoad */
    const [fbsMeta, setFbsMeta] = useState(getFbsMetaLS());

    const goToNextScreen = () => {
        navigate(paths.tabletView.fbs.feedback, { replace: true });
    };
    const goToNextScreenQR = () => {
        navigate(paths.tabletView.fbs.feedbackQR, { replace: true });
    };

    const [locations, setLocations] = useState([]);
    useEffect(() => {
        axios
            .post("/fbs/locations/list", { org_id: user?.hotel_id })
            .then((r) => {
                const data = Array.isArray(r.data) ? r.data : [];
                const uniqueById = [
                    ...new Map(data.map((l) => [l.id, l])).values(),
                ];
                setLocations(uniqueById);
                reset({
                    ...fbsMeta,
                    location:
                        fbsMeta?.location?.id ?? fbsMeta?.location ?? null,
                });
            });
    }, []);
    /* Form */
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            ...fbsMeta,
            location: fbsMeta?.location?.id ?? fbsMeta?.location ?? null,
        },
    });

    const locationOptions = useMemo(() => {
        const nameCounts = {};
        locations.forEach((l) => {
            nameCounts[l.location] = (nameCounts[l.location] || 0) + 1;
        });
        return locations.map((l) => ({
            ...l,
            label:
                nameCounts[l.location] > 1
                    ? `${l.location} (#${l.id})`
                    : l.location,
        }));
    }, [locations]);

    const selectedLocationId = watch("location");
    const selectedLocation = useMemo(() => {
        const id =
            typeof selectedLocationId === "object"
                ? selectedLocationId?.id
                : Number(selectedLocationId);
        if (!id) return null;
        return locationOptions.find((l) => l.id === id) ?? null;
    }, [locationOptions, selectedLocationId]);

    const prepareFbsDataForLS = (formDataPassed) => {
        if (!formDataPassed.location) {
            alert("Please set location");
            return;
        }
        console.log(formDataPassed);
        const formData = { ...formDataPassed };
        formData.id = parseInt(formData.location);
        formData.location = locations.find((l) => l.id === formData.id);
        delete formData.id;
        formData.org_id = user?.hotel_id;
        console.log(formData);
        return !!setStorage("fbsMeta", formData);
    };

    const onSubmit = (formDataPassed) => {
        if (prepareFbsDataForLS(formDataPassed)) goToNextScreen();
    };
    const onSubmitQR = (formDataPassed) => {
        if (prepareFbsDataForLS(formDataPassed)) goToNextScreenQR();
    };

    /* Toggle Fullscreen */
    const [fullscreen, setFullscreen] = useState(false);
    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setFullscreen(true);
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
            setFullscreen(false);
        }
    };

    return (
        <div
            className={"animate__animated animate__zoomIn"}
            style={{ width: "100%", height: "100vh", display: "flex" }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <small className="opa-050">
                    <span className="fa fa-user-shield"></span> ADMIN CONFIG
                </small>
                <h3
                    style={{ margin: 0, marginTop: 10 }}
                    className="theme-color theme-primary"
                >
                    Hello, {user?.fname || user?.name}!
                    <br />
                    You are currently setup to manage{" "}
                    <span className="col-green">{user.hotel.name}</span>
                </h3>
                <p style={{ marginTop: 15 }}>
                    If this is wrong, please change the association via the{" "}
                    <span>Admin Panel</span>, <br />
                    or contact your system admin
                </p>
                <form className="fbs-form bg-glass">
                    <div style={{ paddingTop: 10 }}>
                        <label htmlFor="tabletName">
                            <small>Tablet Identifier/Name</small>
                        </label>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                                <h3>{fbsMeta?.tabUid}-</h3>
                                <input
                                    type="text"
                                    {...register("tabUid", {
                                        required: true,
                                        maxLength: 96,
                                    })}
                                    className="fbs-form-input"
                                    style={{ display: "none" }}
                                />
                            </div>
                            <input
                                type="text"
                                {...register("tabName", {
                                    required: true,
                                    maxLength: 96,
                                })}
                                className="fbs-form-input"
                            />
                        </div>
                        <ErrorMessage
                            errors={errors}
                            name="tabName"
                            render={({ message }) => (
                                <span className="inline-error inline-error-block">
                                    {message || "Tab Name is Required"}
                                </span>
                            )}
                        />
                    </div>
                    <h4
                        style={{ paddingTop: 0, fontSize: "1.05rem" }}
                        className="theme-color theme-primary"
                    >
                        {getLocationIcon()} Select the location of{" "}
                        <span className="col-green">this tablet</span> inside of{" "}
                        {user.hotel.name}
                    </h4>
                    <div
                        style={{
                            position: "relative",
                            zIndex: 100,
                            paddingTop: 0,
                        }}
                    >
                        <label htmlFor="setLocations">
                            <small>Location</small>
                        </label>
                        {/* <select name="setLocations" id="setLocations" className="fbs-form-input"
                            {...register("location", {required: true, maxLength: 96})}
                        >
                            {
                                locations?.map( (l,i) => {
                                    return <option key={l.id} value={l.id}>{l.location}</option>
                                })
                            }
                        </select> */}
                        <Autocomplete
                            options={locationOptions}
                            id="setLocations"
                            value={selectedLocation}
                            onChange={(e, val) => {
                                if (!val) setValue("location", null);
                                else setValue("location", val.id);
                            }}
                            getOptionLabel={(option) =>
                                option?.label ?? option?.location ?? ""
                            }
                            isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                            }
                            renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={option.id} {...optionProps}>
                                        {option.label ?? option.location}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className="fbs-form-input"
                                />
                            )}
                        />
                        <ErrorMessage
                            errors={errors}
                            name="location"
                            render={({ message }) => (
                                <span className="inline-error inline-error-block">
                                    {message ||
                                        "Please select the location of the tablet"}
                                </span>
                            )}
                        />
                    </div>
                    <div
                        className="fbs-form-section-sub"
                        style={{ marginTop: 30 }}
                    >
                        {/* Fullscreen button */}
                        <Button
                            type="submit"
                            modifier="large"
                            onClick={handleSubmit(onSubmitQR)}
                            className="theme-color theme-primary-bg-dark"
                        >
                            Set and show QR 🏁 &raquo;
                        </Button>
                        <Button
                            type="submit"
                            modifier="large--cta"
                            onClick={handleSubmit(onSubmit)}
                            className="theme-color theme-primary-bg"
                        >
                            Set and show Ratings 😐🙂😄 &raquo;
                        </Button>
                        <div style={{ marginTop: 30 }}>
                            <Button
                                onClick={toggleFullScreen}
                                modifier="large--quiet"
                            >
                                {fullscreen
                                    ? "Exit Fullscreen"
                                    : "Go Fullscreen"}
                            </Button>
                        </div>
                    </div>
                </form>
                <div style={{ paddingTop: 10 }}>{/*Spacer*/}</div>
            </div>
        </div>
    );
}

// Re-export RenderHeader from fbs-common for backward compatibility
export { RenderHeader } from "./fbs-common";

export const RenderFooter = ({ externalOpen, onExternalClose } = {}) => {
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        formState: { errors },
        control,
    } = useForm();
    const hasExternalLogout = externalOpen !== undefined;
    const [localOpen, setLocalOpen] = useState(false);
    /* Derive open state: either power-off button (local) or Oman brand div (external) */
    const isModalOpen = localOpen || (externalOpen ?? false);
    const onCloseModal = () => {
        setLocalOpen(false);
        onExternalClose?.();
    };
    const onOpenModal = () => setLocalOpen(true);
    const onSubmit = async (formData) => {
        try {
            let res = await axios.post("/auth", {
                u: formData.username,
                p: formData.password,
            });
            logout();
        } catch (e) {
            onCloseModal();
            reset();
        }
    };
    let navigate = useNavigate();
    const logout = () => {
        deleteStorage("u4");

        /* Remove FBS Meta, but keep `tabUid` and `tabName` */
        const fbsMeta = getStorage("fbsMeta") || {};
        fbsMeta.org_id = null;
        fbsMeta.location = null;
        setStorage("fbsMeta", fbsMeta);

        navigate(paths.root.login);
    };
    return (
        <div id="footer" className="opa-050">
            <div>
                {/* Left */}
                {!hasExternalLogout && (
                    <span
                        className="fa fa-power-off cur-pointer"
                        onClick={onOpenModal}
                    ></span>
                )}
            </div>
            {!hasExternalLogout && (<div id="footer-powered-by">
                <span className="footer-text-visible">
                    Powered by {COMPANY_BRAND_NAME}
                </span>
            </div> )}
            <div id="footer-location">
                {/* Right */}
                <span id="current-loc" className="footer-text-visible">
                    {getLocationIcon()} {getLocationNameLS()}
                </span>
            </div>
            <AlertDialog isOpen={isModalOpen} onCancel={onCloseModal} cancelable>
                <div className="alert-dialog-title">Authenticate Logout</div>
                <div className="alert-dialog-content">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input
                            type="username"
                            id="fbs-logout-input"
                            placeholder="Username"
                            {...register("username", { required: true })}
                        />
                        <input
                            type="password"
                            id="fbs-logout-input"
                            placeholder="Password"
                            {...register("password", { required: true })}
                        />
                        <button className="alert-dialog-button">Logout</button>
                    </form>
                    <button
                        onClick={onCloseModal}
                        className="alert-dialog-button"
                    >
                        Cancel
                    </button>
                </div>
            </AlertDialog>
        </div>
    );
};

/* COMMON CONST/FNS - now in fbs-common.js */
export {
    getLocationNameLS,
    getLocationIcon,
    getLocationIdLS,
} from "./fbs-common";
